/*
 * Gift a Square - product page gift form.
 *
 * Extracted from the custom_liquid block in templates/product.json, where it
 * was invisible to Theme Check and could be overwritten by the theme editor.
 * Markup and styles live in snippets/gift-a-square.liquid.
 */
(function () {
  // This script is loaded on every product page, but the gift form only
  // exists where the 'gift-a-square' snippet is rendered. Bail out cleanly
  // everywhere else rather than throwing on a missing element.
  if (!document.getElementById('sbs-is-gift-checkbox')) return;

  function byId(id) { return document.getElementById(id); }

  /* --- Flower selection from URL params --- */
  var urlParams = new URLSearchParams(window.location.search);
  var flowerId = urlParams.get('flower');
  var flowerName = urlParams.get('flower_name');
  var flowerBanner = byId('sbs-flower-banner');
  var flowerIdInput = byId('sbs-flower-id');
  var flowerNameInput = byId('sbs-flower-name');
  var displayFlower = byId('sbs_display_flower');

  if (flowerId && flowerName) {
    byId('sbs-flower-display-name').textContent = flowerName;
    byId('sbs-flower-display-num').textContent = ' — Love Square #' + flowerId + ' of 100';
    flowerBanner.classList.add('is-visible');
    flowerIdInput.disabled = false;
    flowerIdInput.value = flowerId;
    flowerNameInput.disabled = false;
    flowerNameInput.value = flowerName;
    displayFlower.disabled = false;
    displayFlower.value = '#' + flowerId + ' ' + flowerName;
  }

  /* Swap main product image to the wildflower photo */
  var flowerImg = urlParams.get('flower_img');
  if (flowerImg) {
    var hiRes = flowerImg.replace(/\?width=\d+/, '?width=1280');
    var mainImg = document.querySelector('.product__media img, .product__media-item img');
    if (mainImg) {
      mainImg.setAttribute('src', hiRes);
      mainImg.setAttribute('srcset', '');
      if (flowerName) mainImg.setAttribute('alt', flowerName);
    }
  }

  /* Keep flower banner in sync when user changes the variant dropdown */
  var variantSelect = document.querySelector('variant-selects select, variant-radios input, select[name="id"]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var sel = variantSelect.options ? variantSelect.options[variantSelect.selectedIndex] : null;
      if (!sel) return;
      var text = sel.textContent.trim();
      var m = text.match(/^#(\d+)\s+(.+)$/);
      if (m) {
        var vid = m[1];
        var vname = m[2];
        byId('sbs-flower-display-name').textContent = vname;
        byId('sbs-flower-display-num').textContent = ' — Love Square #' + vid + ' of 100';
        flowerBanner.classList.add('is-visible');
        flowerIdInput.disabled = false;
        flowerIdInput.value = vid;
        flowerNameInput.disabled = false;
        flowerNameInput.value = vname;
        displayFlower.disabled = false;
        displayFlower.value = '#' + vid + ' ' + vname;
      }
    });
  }

  var changeLink = byId('sbs-flower-change');
  if (changeLink) {
    changeLink.addEventListener('click', function () {
      window.history.back();
    });
  }

  var isGift = byId('sbs-is-gift-checkbox');
  var giftFields = byId('sbs-gift-fields');

  var recipientName = byId('sbs-gift-recipient-name');
  var recipientEmail = byId('sbs-gift-recipient-email');
  var giftMessage = byId('sbs-gift-message');

  var sendDateField = byId('sbs-send-date-field');
  var sendLocal = byId('sbs-send-date-local');

  // Hidden storage (timezone-safe; keeps old key _sbs_send_date)
  var sendIso = byId('sbs-send-date-iso');
  var sendTz = byId('sbs-send-tz');
  var sendTzOffset = byId('sbs-send-tz-offset');

  // Display props
  var dIsGift = byId('sbs_display_is_gift');
  var dRecipientName = byId('sbs_display_recipient_name');
  var dRecipientEmail = byId('sbs_display_recipient_email');
  var dGiftMessage = byId('sbs_display_gift_message');
  var dSendDate = byId('sbs_display_send_date');

  // Visual selected state
  var giftToggleRow = document.querySelector('.gift-form .gift-toggle');

  function setEnabled(el, enabled) {
    if (!el) return;
    // Disabling is enough to keep the field out of the submission — do NOT clear
    // the value, or an accidental toggle-off wipes everything the customer typed.
    el.disabled = !enabled;
  }

  function setDisplayProp(el, enabled, value) {
    if (!el) return;
    el.disabled = !enabled;
    el.value = enabled ? (value || '') : '';
  }

  function pad2(n) { return String(n).padStart(2, '0'); }

  // datetime-local value: "YYYY-MM-DDTHH:MM"
  function toLocalDateTimeValue(date) {
    var y = date.getFullYear();
    var m = pad2(date.getMonth() + 1);
    var d = pad2(date.getDate());
    var hh = pad2(date.getHours());
    var mm = pad2(date.getMinutes());
    return y + '-' + m + '-' + d + 'T' + hh + ':' + mm;
  }

  // Parse "YYYY-MM-DDTHH:MM" into a local Date
  function parseLocalDateTime(value) {
    if (!value) return null;
    var parts = value.split('T');
    if (parts.length !== 2) return null;

    var d = parts[0].split('-').map(Number);
    var t = parts[1].split(':').map(Number);
    if (d.length !== 3 || t.length < 2) return null;

    return new Date(d[0], d[1] - 1, d[2], t[0], t[1], 0, 0);
  }

  // ISO with offset, e.g. 2026-01-21T10:30:00+11:00
  function toIsoWithOffset(date) {
    var y = date.getFullYear();
    var m = pad2(date.getMonth() + 1);
    var d = pad2(date.getDate());
    var hh = pad2(date.getHours());
    var mm = pad2(date.getMinutes());
    var ss = '00';

    var off = -date.getTimezoneOffset(); // minutes ahead of UTC
    var sign = off >= 0 ? '+' : '-';
    var abs = Math.abs(off);
    var oh = pad2(Math.floor(abs / 60));
    var om = pad2(abs % 60);

    return y + '-' + m + '-' + d + 'T' + hh + ':' + mm + ':' + ss + sign + oh + ':' + om;
  }

  function setDefaultSendDateIfEmpty() {
    if (!sendLocal) return;
    if (!sendLocal.value) {
      var now = new Date();
      var ms = 5 * 60 * 1000; // round up to nearest 5 minutes
      now = new Date(Math.ceil(now.getTime() / ms) * ms);
      sendLocal.value = toLocalDateTimeValue(now);
    }
  }

  function syncSendDateTimezoneFields() {
    var tzName = '';
    try {
      tzName = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (e) {}

    if (sendTz) sendTz.value = tzName;

    // Keep offset in minutes behind UTC (JS convention)
    if (sendTzOffset) sendTzOffset.value = String(new Date().getTimezoneOffset());

    var dt = parseLocalDateTime(sendLocal.value);
    if (!dt) {
      if (sendIso) sendIso.value = '';
      return;
    }
    if (sendIso) sendIso.value = toIsoWithOffset(dt);
  }

  function formatForHuman(date, tzName) {
    try {
      var dt = new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit'
      }).format(date);

      return tzName ? (dt + " (" + tzName + ")") : dt;
    } catch (e) {
      return date.toString();
    }
  }

  function syncDisplayProps() {
    var giftEnabled = !!isGift.checked;

    setDisplayProp(dIsGift, giftEnabled, giftEnabled ? 'Yes' : '');
    setDisplayProp(dRecipientName, giftEnabled, recipientName.value);
    setDisplayProp(dRecipientEmail, giftEnabled, recipientEmail.value);
    setDisplayProp(dGiftMessage, giftEnabled, giftMessage.value);

    // Human-friendly send date in THEIR timezone
    var dt = parseLocalDateTime(sendLocal.value);
    var tzName = (sendTz && sendTz.value) ? sendTz.value : '';
    var human = dt ? formatForHuman(dt, tzName) : '';
    setDisplayProp(dSendDate, giftEnabled, human);
  }

  function toggleGift() {
    var enabled = !!isGift.checked;
    giftFields.style.display = enabled ? 'block' : 'none';
    if (giftToggleRow) giftToggleRow.classList.toggle('is-checked', enabled);

    var inputs = giftFields.querySelectorAll('input, textarea');
    inputs.forEach(function (el) {
      setEnabled(el, enabled);
    });

    recipientName.required = enabled;
    recipientEmail.required = enabled;
    sendLocal.required = enabled;

    sendDateField.style.display = enabled ? 'block' : 'none';

    if (enabled) {
      setDefaultSendDateIfEmpty();
      syncSendDateTimezoneFields();
    } else {
      if (sendIso) sendIso.value = '';
      if (sendTz) sendTz.value = '';
      if (sendTzOffset) sendTzOffset.value = '';
    }

    syncDisplayProps();
  }

  // Clear the form once an item is actually in the cart, so a second item can
  // never inherit the first recipient's name, email or message. The fields sit
  // outside <form> (they associate via form="product-form-*"), so nothing resets
  // them otherwise. Mirrors how Dawn's own gift-card recipient form clears
  // itself -- see assets/recipient-form.js.
  function resetGiftForm() {
    isGift.checked = false;
    [recipientName, recipientEmail, giftMessage, sendLocal].forEach(function (el) {
      if (el) el.value = '';
    });
    toggleGift();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form') resetGiftForm();
    });
  }

  // Wire up events
  isGift.addEventListener('change', function () {
    toggleGift();

    // Fires once per real state change. Autocapture cannot be used to measure
    // this: the label targets the input via for=, so a single click on the
    // label (which is the dominant hit target at flex: 1) produces two
    // autocaptured click events -- one on the label, one synthesized on the
    // input -- roughly doubling any "toggled more than once" metric.
    if (window.posthog) {
      posthog.capture('gift_toggled', {
        enabled: isGift.checked,
        page_path: window.location.pathname,
      });
    }
  });

  recipientName.addEventListener('input', syncDisplayProps);
  recipientEmail.addEventListener('input', syncDisplayProps);
  giftMessage.addEventListener('input', syncDisplayProps);

  sendLocal.addEventListener('change', function () {
    syncSendDateTimezoneFields();
    syncDisplayProps();
  });
  sendLocal.addEventListener('input', function () {
    syncSendDateTimezoneFields();
    syncDisplayProps();
  });

  // Initialise on load
  toggleGift();

  /* Deep-link entry from the subscribe page's gift block:
       ?sbs_gift=1  opens the gift form pre-checked
       ?sbs_sub=1   selects Appstle's subscription option once its widget
                    renders — our Appstle config honours no native URL
                    preselect (?selling_plan= is dropped; verified 2026-08-11),
                    so we pick the radio whose label reads like a monthly plan. */
  (function () {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (q.get('sbs_gift') === '1' && !isGift.checked) {
      isGift.checked = true;
      isGift.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (q.get('sbs_sub') === '1') {
      var tries = 0;
      var pick = setInterval(function () {
        var radios = document.querySelectorAll(
          '.appstle_include_widget input[type=radio], .appstle_subscription_wrapper input[type=radio]'
        );
        for (var i = 0; i < radios.length; i++) {
          var label = radios[i].closest('label') ||
            (radios[i].id ? document.querySelector('label[for="' + radios[i].id + '"]') : null);
          var txt = label ? label.textContent : '';
          if (/month/i.test(txt) && !/once/i.test(txt)) {
            if (!radios[i].checked) radios[i].click();
            clearInterval(pick);
            return;
          }
        }
        if (++tries >= 40) clearInterval(pick); // widget never rendered; give up quietly
      }, 250);
    }
  })();
})();
